(function(){
  var roots=document.querySelectorAll('.oo[data-next-drop]');
  roots.forEach(function(root){
    if(root.dataset.ooReady) return;
    root.dataset.ooReady='1';
    var firstDrop=Date.parse(root.dataset.nextDrop||'');
    var available=root.dataset.available==='true';
    var button=root.querySelector('[data-oo-buy]');
    var status=root.querySelector('[data-oo-status]');
    var label=root.querySelector('[data-oo-clock-label]');
    var notice=root.querySelector('[data-oo-notice]');
    var hours=root.querySelector('[data-oo-hours]');
    var minutes=root.querySelector('[data-oo-minutes]');
    var seconds=root.querySelector('[data-oo-seconds]');
    var day=86400000;
    function two(x){return String(x).padStart(2,'0');}
    function render(){
      if(!available){
        if(status)status.textContent='SOLD OUT';
        if(label)label.textContent='GONE FOREVER';
        if(button){button.disabled=true;button.textContent='SOLD — GONE FOREVER';}
        if(notice)notice.textContent='This one-of-one has sold. No remakes.';
        if(hours)hours.textContent='00';
        if(minutes)minutes.textContent='00';
        if(seconds)seconds.textContent='00';
        return;
      }
      if(status)status.textContent='LIVE — ONLY ONE';
      if(button){button.disabled=false;button.textContent='I WANT IT — BUY THE ONLY ONE';}
      if(!Number.isFinite(firstDrop)){
        if(label)label.textContent='NEXT PRICE DROP TO BE ANNOUNCED';
        return;
      }
      var now=Date.now();
      var target=now<firstDrop ? firstDrop : firstDrop+(Math.floor((now-firstDrop)/day)+1)*day;
      var remaining=Math.max(0,Math.ceil((target-now)/1000));
      if(hours)hours.textContent=two(Math.floor(remaining/3600));
      if(minutes)minutes.textContent=two(Math.floor((remaining%3600)/60));
      if(seconds)seconds.textContent=two(remaining%60);
      if(label)label.textContent='PRICE DROPS IN';
      if(notice)notice.textContent='First drop at midnight after Wednesday 4 November, Dubai time. Waiting risks losing it.';
    }
    render();
    setInterval(render,1000);
  });
})();